import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { translate } from '../../../i18n';

interface MarkPayLaterAsPaidResponse {
    success: boolean;
    originalPaymentIntentId: string;
    method: string;
    message: string;
}

export const useMarkPayLaterAsPaid = () => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const apiClient = useApiClient();
    return useMutation({
        mutationFn: async ({
            paymentIntentId,
            method,
        }: {
            paymentIntentId: string;
            method: 'manual_card' | 'manual_cash';
        }) => {
            return apiClient.fetchApi<MarkPayLaterAsPaidResponse, { method: string }>({
                endpoint: `payments/mark-pay-later-as-paid/${paymentIntentId}`,
                method: 'POST',
                body: { method },
            });
        },
        onSuccess: (_data, variables) => {
            toast({
                title: translate('game.mark_paid_success'),
                description: variables.method === 'manual_card'
                    ? translate('game.mark_paid_card')
                    : translate('game.mark_paid_cash'),
                status: 'success',
                duration: 5000,
                isClosable: true,
            });
            queryClient.invalidateQueries({ queryKey: ['game'] });
        },
        onError: (error: any) => {
            toast({
                title: translate('game.mark_paid_error'),
                description: error?.message || translate('common.unexpected_error'),
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        },
    });
};
